import AreasContainer from './areas-container';

export default AreasContainer;